import type { TFunction } from 'i18next';

import type { ProductSchedule } from '@nucleus-commerce/api-client/admin';

type Cadence = Pick<ProductSchedule, 'intervalDays' | 'runAt'>;

/**
 * "every day at 09:00" / "every 7 days at 09:00": pluralised on the days, never on the live
 * count, so every sentence that describes a cadence builds on this.
 */
export function cadenceEvery(t: TFunction, { intervalDays, runAt }: Cadence): string {
  return t('schedules:cadence.every', { count: intervalDays, runAt });
}

/** "12 live, every 7 days at 09:00". */
export function cadenceSummary(
  t: TFunction,
  schedule: Cadence & Pick<ProductSchedule, 'liveCount'>,
): string {
  return t('schedules:cadence.summary', {
    count: schedule.liveCount,
    every: cadenceEvery(t, schedule),
  });
}
